module.exports = __webpack_public_path__ + "static/media/banana.bc1bab17.png";